import { Link, To } from "react-router";
import { cn } from "@util/helpers";

export type CardTitleProps = {
  /** Optional additional styling for the container */
  className?: string;
  /** The title of the card */
  title: string;
  /** Optional link to the article */
  to?: To;
  /** Optional class name for the link root */
  linkRootClassName?: string;
  /** The article ID for data attributes */
  articleId: string;
  /** Flag to indicate if the title should be an H1 element */
  isH1?: boolean;
  /** Optional additional styling for the span inside the title */
  spanClassName?: string;
};

/**
 * CardTitle component that renders a title for the card.
 * It can be an H1 or H3 element and can link to an article.
 */
const CardTitle = ({
  className,
  linkRootClassName,
  title,
  to,
  articleId,
  isH1 = false,
  spanClassName,
}: CardTitleProps): React.ReactElement => {
  const Heading = isH1 ? "h1" : "h3";

  const testId = "card-title-component";

  if (typeof to === "undefined") {
    return (
      <Heading
        className={className}
        data-testid={testId}
        data-article-id={articleId}
      >
        <span className={cn("inline-block", spanClassName)}>{title}</span>
      </Heading>
    );
  }

  return (
    <Heading
      className={className}
      data-testid={testId}
      data-article-id={articleId}
    >
      <Link
        className={cn("inherit word-break", linkRootClassName)}
        to={to}
        rel="noopener"
        title={title}
        reloadDocument
      >
        <span className={cn("inline-block hover:underline", spanClassName)}>
          {title}
        </span>
      </Link>
    </Heading>
  );
};

export default CardTitle;
